{
  "comment": "Reach HUD tuning (M3 plan R15). Validated by src/hud/reach/config.ts. The cruise, interdiction and relay thresholds come from reach-travel.json; scan.holdS mirrors reach-explore.json scanner.holdS (R18). labels.caps are the HUD labels setting (Full / Reduced / Minimal; spec 2026-10-09 H2): how many full labels show, the rest keep the icon. labels.kindRank orders nearby labels (lower first, then nearer first); labels.declutter sizes the screen rectangles of the greedy overlap test. edgeMarkers is the safe rectangle edge-pinned nav markers stay inside (clear of the screen edge and the status, weapons and cruise panels), their side spacing, and the room kept around an edge arrow. Starting values, tune freely.",
  "nav": { "edgeMarginPx": 64 },
  "labels": {
    "rangeM": 50000,
    "max": 12,
    "minDistanceM": 150,
    "mode": "reduced",
    "caps": { "full": 10, "reduced": 6, "minimal": 0 },
    "kindRank": { "station": 0, "relay": 1, "poi": 2, "laneRing": 3 },
    "declutter": {
      "charPx": 8,
      "distChars": 7,
      "platePadPx": 12,
      "plateHeightPx": 20,
      "offsetXPx": 8,
      "markerHalfHeightPx": 16,
      "markerTextPx": 46,
      "reticleRadiusPx": 140,
      "fadeStartM": 10000,
      "fadeMinOpacity": 0.55
    }
  },
  "edgeMarkers": { "insetPx": { "left": 24, "right": 24, "top": 120, "bottom": 170 }, "spacingPx": 26, "arrowRectPx": { "left": 44, "right": 44, "up": 20, "down": 34 } },
  "farMarkers": { "max": 16, "minDistanceM": 50000, "opacity": 0.55, "hideCruiseThrottle": 0.95, "busyCount": 6 },
  "scan": { "holdS": 3, "pingS": 1.2 },
  "banner": {
    "seconds": 6,
    "fadeInS": 0.4,
    "fadeOutS": 1.2,
    "text": { "owned": "{faction} space", "unowned": "Unclaimed", "unclaimed": "unclaimed" }
  },
  "toasts": { "max": 4, "queue": 16, "seconds": 4.5, "fadeS": 0.6, "coalesceS": 2 },
  "cruise": { "promptMinDistanceM": 10000 },
  "device": { "padAxisThreshold": 0.35 }
}
